import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';
@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss']
})
export class HowItWorksComponent implements OnInit {

  safeURL; //youTube Video URL //

  constructor(
    private meta: Meta, 
    private title: Title, 
    private _sanitizer: DomSanitizer,
    private metaService: MetaServiceService
    ) {
    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'CViewSurvey works on the customer satisfaction survey. With our unique C.A.A.G. Collect, Analysis, Act & Grow approach through this you will grow your business.' },
      { name: 'author', content: 'CViewSurvey' },
      { 
        name: 'keywords',
        content: 'Collect data , Feedback application , Customer satisfaction , Analysis the feedback data , Act on feedback , Survey templates  , Grow your business , CViewSurvey application' ,  },
    ]);

    this.setTitle('How It Works | Customer Satisfaction Survey | Feedback Application');
    // End SEO Meta Description


    // You Tube Video Description
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/O5rgp4xbB88?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1');
    // End You Tube Video Description  
  }

  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description

  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();
  }

}
